// Copyright (c) Docugami, Inc. All rights reserved.

import styled from 'styled-components';
import { useEffect } from 'react';
import { SmallContent } from 'components/common/Fonts';
import { DgButton } from 'components/common/DgCommonStyledComponents';
import { useLocation } from 'react-router';
import { useDgAuth } from 'hooks/DgAuthentication';
import { DgUnauthenticatedShell } from 'components/shell/presentation/Header';
import { Telemetry } from 'telemetry/TelemetryManager';
import { TelemetryPageView } from 'telemetry/TelemetryEvents';

const Root = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 20px;
    min-height: 500px;
    align-self: center;
    justify-self: center;
    width: 100%;
`;

const TextContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 15px;
    align-items: center;
`;

const MessageContainer = styled.div`
    text-align: center;
    max-width: 600px;
`;

const RedirectButton = styled(DgButton)`
    width: fit-content;
    margin-top: 10px;
`;

interface SessionExpiredPageProps {
    location: any;
}

interface SessionExpiredPageUXProps extends SessionExpiredPageProps {
    onTrySignIn: () => void;
}

export const EmailVerificationPage = (props: SessionExpiredPageUXProps): JSX.Element => {
    const { loginWithRedirect } = useDgAuth();
    const search = useLocation().search;
    const userEmail = new URLSearchParams(search).get('email');

    useEffect(() => {
        Telemetry.trackPageView(TelemetryPageView.EmailVerification);
    }, []);

    return (
        <DgUnauthenticatedShell>
            <Root>
                <img src='assets/VerifyEmail.png' alt='Email Message'/>
                <TextContainer>
                    <MessageContainer>
                        <SmallContent>An email has been sent to <b>{decodeURIComponent(userEmail!)}</b> with email verification instructions. After you have completed verification, you can log in by clicking the button below.</SmallContent>
                    </MessageContainer>
                    <RedirectButton key={'retry_login'} onClick={loginWithRedirect}>Log in</RedirectButton>
                </TextContainer>
            </Root>
        </DgUnauthenticatedShell>
    )
}
